// src/monitoring/MonitoringShell.jsx
//
// Frame of the Asset Monitoring section: title, refresh, the project / auth
// guards, the "simulated" badge when any park is on the simulated source, and
// the outlet the pages render into. Navigation between pages is the sidebar's.

import React from "react";
import { Outlet } from "react-router-dom";
import { Alert, Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import { MonitoringProvider, useMonitoring } from "./MonitoringContext";
import { useMonitoringText } from "./i18n";
import { ReplayBadge, SimulatedBadge } from "./components/primitives";
import { useDemo } from "../context/DemoContext";
import { getMonitoringDisabledMessage } from "../utils/demoAccess";

function Shell() {
  const m = useMonitoring();
  const t = useMonitoringText();
  return (
    <Box sx={{ p: { xs: 1.5, md: 3 } }}>
      <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 0.5 }} flexWrap="wrap">
        <Typography variant="h5" sx={{ fontWeight: 800 }}>{t("shell.title")}</Typography>
        {m.portfolio?.simulated && <SimulatedBadge />}
        {m.portfolio?.replay && <ReplayBadge />}
        <Box sx={{ flex: 1 }} />
        <Button onClick={m.refresh} disabled={m.loading || !m.projectId}>{t("shell.refresh")}</Button>
      </Stack>
      <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>{t("shell.subtitle")}</Typography>
      {!m.projectId ? <Alert severity="info">{t("shell.noProject")}</Alert>
        : !m.authenticated ? <Alert severity="info">{t("shell.signIn")}</Alert>
        : m.error && !m.loaded ? <Alert severity="error" action={<Button color="inherit" size="small" onClick={m.refresh}>{t("common.retry")}</Button>}>{m.error}</Alert>
        : !m.loaded ? <Stack direction="row" spacing={1} alignItems="center"><CircularProgress size={22} /><Typography variant="body2">{t("shell.loading")}</Typography></Stack>
        : <Outlet />}
    </Box>
  );
}

export default function MonitoringShell() {
  const { demoProfile, demoError } = useDemo();
  if (!demoProfile && !demoError) return null;
  if (demoError) {
    return <Box sx={{ p: 3 }}><Alert severity="error">Account permissions are unavailable. Please refresh.</Alert></Box>;
  }
  const disabled = getMonitoringDisabledMessage(demoProfile);
  if (disabled) return <Box sx={{ p: 3 }}><Alert severity="info">{disabled}</Alert></Box>;
  return <MonitoringProvider><Shell /></MonitoringProvider>;
}
